import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import { commaFormat, commaFormatCurrency } from '@ltvco/refresh-lib/utils';

import { VehicleReportSummaryData } from '../DataTypes/SummaryTypes';

interface VehicleReportRendererProps {
  data: VehicleReportSummaryData;
}

export const VehicleReportRenderer = ({ data }: VehicleReportRendererProps) => {
  const vehicleDetails = data.flatVehicleReport.vehicles_info?.vehicle_details;
  const vehicleYear = vehicleDetails?.year || 'N/A';
  const vehicleMake = vehicleDetails?.make || 'N/A';
  const vehicleModel = vehicleDetails?.model || 'N/A';
  const vehicleTrim = vehicleDetails?.trim || '';
  const vehicleFullName =
    `${vehicleYear} ${vehicleMake} ${vehicleModel} ${vehicleTrim}`.trim();

  return (
    <Stack spacing={2}>
      {data.flatVehicleReport.vehicles_info?.searchSource && (
        <Text>
          We found 1 result for the vehicle with{' '}
          <span style={{ fontWeight: 700 }}>
            {data.flatVehicleReport.vehicles_info?.searchSource}
          </span>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text sx={{ fontWeight: 700, mb: 1 }}>Vehicle Specs:</Text>
          <Text>
            <span style={{ fontWeight: 700 }}>Vehicle:</span> {vehicleFullName}
          </Text>
          <Text>
            <span style={{ fontWeight: 700 }}>Body Style:</span>{' '}
            {vehicleDetails?.body_style || 'N/A'}
          </Text>
          <Text>
            <span style={{ fontWeight: 700 }}>Type:</span>{' '}
            {vehicleDetails?.type || 'N/A'}
          </Text>
          <Text>
            <span style={{ fontWeight: 700 }}>Color:</span>{' '}
            {vehicleDetails?.current_color || 'N/A'}
          </Text>
          <Text sx={{ mb: 1 }}>
            <span style={{ fontWeight: 700 }}>Made In:</span>{' '}
            {data.flatVehicleReport.property_or_address_info?.state || 'N/A'},{' '}
            {data.flatVehicleReport.property_or_address_info?.country || 'N/A'}
          </Text>
        </Box>

        {(data.flatVehicleReport.vehicles_info?.pricing?.invoice_price ||
          data.flatVehicleReport.vehicles_info?.estimated_mileage?.miles) && (
          <Box>
            <Text sx={{ fontWeight: 700, mb: 1 }}>History & Value:</Text>
            <Text sx={{ mb: 1 }}>
              {data.flatVehicleReport.vehicles_info?.pricing?.invoice_price && (
                <>
                  <span style={{ fontWeight: 700 }}>💰 Invoice Price:</span>{' '}
                  {commaFormatCurrency(
                    Number(
                      data.flatVehicleReport.vehicles_info?.pricing
                        ?.invoice_price
                    )
                  )}
                </>
              )}
            </Text>
            <Text sx={{ mb: 1 }}>
              {data.flatVehicleReport.vehicles_info?.estimated_mileage
                ?.miles && (
                <>
                  <span style={{ fontWeight: 700 }}>Estimated Mileage:</span>{' '}
                  {commaFormat(
                    Number(
                      data.flatVehicleReport.vehicles_info?.estimated_mileage
                        ?.miles
                    )
                  )}{' '}
                  miles
                </>
              )}
            </Text>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
